import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PUBLISHABLE_API_KEY = process.env.REACT_APP_STOREFRONT_API_KEY;

/**
 * Fetch the public storefront configuration that decides which front-end
 * (static vs. dynamic) gets rendered for customer-facing routes.
 *
 * GET /store/public/configurations → { configuration: { ..., enable_static_site } }
 *
 * Returns the raw `configuration` object on success, or `null` on failure so
 * the caller can fall back to a default mode.
 */
export const fetchPublicConfig = async () => {
  if (!API_BASE_URL) return null;
  try {
    const res = await axios.get(`${API_BASE_URL}/store/public/configurations`, {
      headers: PUBLISHABLE_API_KEY
        ? { 'x-publishable-api-key': PUBLISHABLE_API_KEY }
        : undefined,
    });
    return res?.data?.configuration || null;
  } catch (err) {
    console.error('Failed to fetch public configuration:', err);
    return null;
  }
};

/**
 * Resolve the `is_static_site` flag from a configuration payload, being
 * permissive about shape (boolean, "true"/"false" strings, 0/1).
 */
export const isStaticSiteEnabled = (config) => {
  if (!config) return false;
  const raw = config.is_static_site;
  if (typeof raw === 'boolean') return raw;
  if (typeof raw === 'number') return raw === 1;
  if (typeof raw === 'string') return raw.toLowerCase() === 'true' || raw === '1';
  return false;
};
